<template>
  <div class="switch-font-box" :class="theme" ref="switchFontSizeRef">
    <img class="nav-icon" :src="imageMap.icon_font" alt="switchFontSize" @click="showSwitchFont" />
    <div class="size-list" :class="showFontStatus">
      <span
        :class="fontSize === 'font_small' ? 'active-color' : ''"
        @click="confirmSize('font_small')"
        >小</span
      >
      <span
        :class="fontSize === 'font_medium' ? 'active-color' : ''"
        @click="confirmSize('font_medium')"
        >中</span
      >
      <span :class="fontSize === 'font_big' ? 'active-color' : ''" @click="confirmSize('font_big')"
        >大</span
      >
    </div>
  </div>
</template>
<script setup>
import { useListenConfigStore } from "@/hooks/useListenConfigStore";
import { imageConfig } from "@/views/listening/components/ThemeTag/imageConfig";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";

const listenStore = useListenConfigStore();

const showFontStatus = ref("fold");

const fontSize = computed(() => listenStore.fontSize);

const theme = computed(() => listenStore.theme);

const imageMap = computed(() => imageConfig[theme.value]);

const switchFontSizeRef = ref();

const showSwitchFont = () => {
  if (showFontStatus.value === "fold") {
    showFontStatus.value = "expand";
  } else {
    showFontStatus.value = "fold";
  }
};

const confirmSize = (size) => {
  listenStore.setFontSize(size);
};

const handleClickOutside = (e) => {
  if (showFontStatus.value === "expand") {
    let isSelf = switchFontSizeRef.value.contains(e.target);
    if (!isSelf && e.target.alt !== "switchFontSize") {
      showFontStatus.value = "fold";
    }
  }
}

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});
</script>
<style scoped lang="less">
.nav-icon {
  width: 1.3rem !important;
}
.switch-font-box {
  position: relative;
  margin-right: 0.5rem;
  display: inline-flex;
  .size-list {
    position: absolute;
    background: #fff;
    width: 6.4rem;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    height: 0;
    transition: height linear 0.1s;
    border-radius: 0.64rem;
    font-size: 1rem;
    font-weight: 400;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 1.5rem;
    text-align: center;
    &.expand {
      height: 2.5rem !important;
      border: 1px solid #eee;
      transition: height linear 0.1s;
    }
    span {
      padding: 0.5rem 0;
      display: inline-block;
      box-sizing: border-box;
      line-height: 1.5;
      color: var(--switch-font-size-color);
    }
  }
}
.active-color {
  color: var(--switch-font-size-active-color) !important;
  font-weight: 500;
}
</style>
<style lang="less">
.switch-font-size {
  font-size: var(--switch-font-size) !important;
  font-weight: 600;
  line-height: 1.3;
}
</style>
